import { addressList, categoryList } from "constant/firebaseUploadConstant";
import { collection, addDoc, doc, getDoc, getDocs, setDoc } from "firebase/firestore"; 
import { firebaseStore } from "util/firebaseUtil";

export const addDocument = async () => {
    try {
        const docRef = await addDoc(collection(firebaseStore, "users"), {
          first: "Ada",
          last: "Lovelace",
          born: 1815
        });
        // console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
      }
}

export const searchDrawerCategoryAddDocument = async () => {
  try {
      // 업로드
      categoryList.forEach((item) => {
        const doc_id = doc(collection(firebaseStore, "category")).id
        setDoc(doc(firebaseStore, "category", doc_id), {
          ...item,
          id: doc_id
        });
      })
      
      // console.log("Document written with ID: ", docRef.id);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
}

export const searchDrawerAddressAddDocument = async () => {
  try {
      // 업로드
      addressList.forEach((item) => {
        const doc_id = doc(collection(firebaseStore, "address")).id
        setDoc(doc(firebaseStore, "address", doc_id), {
          ...item,
          id: doc_id
        });
      })
      
      // console.log("Document written with ID: ", docRef.id);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
}

export const searchDrawerReadDocument = async (collectionId: string) => {
    return await getDocs(collection(firebaseStore, collectionId));
}